// ### INICIO - Scripts Gerais ###

//Validador de CNPJ
export function formataCNPJ(cnpj) {
  // Remove tudo o que não é dígito
  cnpj = cnpj.replace(/\D/g, '');

  // Adiciona a máscara de CNPJ
  cnpj = cnpj.replace(/^(\d{2})(\d)/, '$1.$2');
  cnpj = cnpj.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
  cnpj = cnpj.replace(/\.(\d{3})(\d)/, '.$1/$2');
  cnpj = cnpj.replace(/(\d{4})(\d)/, '$1-$2');

  return cnpj;
}


//Função apenas números
export function somenteNumeros(texto) {
    var numeros = texto.replace(/[^0-9]/g,'');
    return parseInt(numeros);
}


//Função para celular (99) 99999-9999
export function formataCelularBr(celular) {
  var regex = /^(\d{2})(\d{5})(\d{4})$/;
  
  // Remove tudo o que não é dígito
  var celular = celular.replace(/\D/g, '');

  celular = celular.replace(regex, "($1) $2-$3");

  return celular;
}

//Função para formatar e-mail
export function formataEmail(email) {
  // Remove espaços em branco no início e no final do e-mail
  email = email.trim();

  // Converte todos os caracteres para minúsculas
  email = email.toLowerCase();

  // Verifica se o e-mail tem um formato válido
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    return null;
  }

  // Retorna o e-mail formatado
  return email;
}

// ### FIM - Scripts Gerais ###